<template>
  <sales-summary
    v-if="entries"
    :entries="entries"
    :loading="loading"
  />
</template>
<script>
import SalesSummary from './SalesSummary';

export default {
  name: 'SalesSummaryContainer',
  components: {
    SalesSummary,
  },
  props: {
    dataRange: {
      type: String,
      required: true,
    },
    profile: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      custom_url: null,
    };
  },
  computed: {
    entries() {
      if (!this.$store.state.profiles.salesOverviewStats) return [];
      return this.$store.state.profiles.salesOverviewStats;
    },
    loading() {
      return this.$store.state.profiles.itemSalesOverviewLoading;
    },
  },
  watch: {
    dataRange(newval) {
      this.fetchCustomData();
    },
    custom_url(newval) {
      this.fetchCustomData();
    },
    profile: {
      handler(newval) {
        if (!newval) return;
        this.fetchData();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    fetchCustomData() {
      if (this.custom_url) {
        const params = {
          url: this.custom_url,
          range: this.dataRange,
          external_id: this.profile.external_id,
        };
        this.$emit('hasCustomUrl');
        this.$store.dispatch('profiles/fetchCustomSalesOverviewData', params);
      }
    },
    fetchData() {
      this.$store.dispatch('profiles/fetchSalesOverviewData', this.profile.pk).then((response) => {
        if (response.data.url) {
          this.custom_url = response.data.url;
        }
      });
    },
  },
};
</script>
